import { useEffect, useState } from 'react'
import { SelectoEvents } from 'react-selecto'
import { IScrollOptions, TSelectoOnAdd, TSelectoOnRemove } from './types'
import { TActiveTimelineItemType } from 'store/types/editor'
import { TRACK_ITEM_CLASS_NAME } from 'consts'

export const useSelectoScroll = (
  scrollableContainerRef: HTMLElement | null
) => {
  const [scrollOptions, setScrollOptions] = useState<IScrollOptions | null>(
    null
  )

  const onScrollEventHandler = (e: SelectoEvents['scroll']) => {
    scrollableContainerRef?.scrollBy(e.direction[0] * 10, e.direction[1] * 10)
  }

  useEffect(() => {
    if (scrollableContainerRef) {
      setScrollOptions({
        container: scrollableContainerRef,
        throttleTime: 10,
        threshold: 30
      })
    } else {
      setScrollOptions(null)
    }
  }, [setScrollOptions, scrollableContainerRef])

  return { scrollOptions, onScrollEventHandler }
}

export const useOnSelect = (
  onAdd: TSelectoOnAdd,
  onRemove: TSelectoOnRemove
) => {
  const onSelect = (e: SelectoEvents['select']) => {
    const added = e.added
    const removed = e.removed
    const isFirstItem = e.selected.length === added.length
    const isRemovingLastItem = removed.length > 0 && e.selected.length === 0

    const addedElements = added
      .filter(element => element.dataset.type && element.dataset.assetId)
      .map(element => ({
        id: element.id,
        type: element.dataset.type as TActiveTimelineItemType,
        assetId: element.dataset.assetId!
      }))

    const removedElementsIds = removed.map(element => element.id)

    if (addedElements.length) {
      onAdd(addedElements, isFirstItem)
    }
    if (removedElementsIds.length) {
      onRemove(removedElementsIds, isRemovingLastItem)
    }
  }

  return onSelect
}

export const useOnDragStart = () => {
  const onDragStart = (event: SelectoEvents['dragStart']) => {
    const target = event.inputEvent.target as HTMLElement

    const isDragNotAllowed = target.closest(`.${TRACK_ITEM_CLASS_NAME}`)
    if (isDragNotAllowed) {
      event.stop()
    }
  }

  return onDragStart
}
